import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import EquipmentGroupActions from "../../Actions/EquipmentGroupActions";
import commonUtils from "../../helpers/commonUtils";
import { useLanguageContext } from "../../Context/LanguageContext";
import TypeAhead from "../AddRole/TypeAhead";
import equipmentGroupStore from "../../Stores/EquipmentGroupStore";
import EquipmentGroupContants from "../../Constants/EquipmentGroupConstants";
import ConfirmationPopUp from "../MessageBox/ConfirmationPopUp";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import { useRef } from "react";
import EnhancedTable from "../ReusableComponent/MuiTable";
import ReusableCard from "../ReusableComponent/ReusableCard";

const AddHerstellerToEquGroup = (props) => {
  const { egDetails, equipmentGrpName, handleCompleted, equipmentGrpId } =
    props.data;
  const [searchedHerstellerList, setSearchedHerstellerList] = useState([]);
  const [herstellerList, setHerstellerList] = useState([]);
  const [selectedHerstellerId, setSelectedHerstellerId] = useState(0);
  const [buttonStatus, setbuttonStatus] = useState(true);
  const [confirmationPopUpOpen, setConfirmationPopUpOpen] = useState(false);
  const [confirmationPopUpMsg, setConfirmationPopUpMsg] = useState("");
  const [listItem, setListItem] = useState([]);
  const [itemSelected, setItemSelected] = useState(0);
  const [callbackData, setCallbackData] = useState(null);
  const [eventType, setEventType] = useState(null);
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const equipmentId = useRef("");
  const typeHeadRef = useRef("");
  const text = (
    <div className="row justify-content-center reusableCard pl-5 pr-5">
      <p>
        {localization.msg1 + " ? " + localization.msg2}
        <span className="reusableCardLink">
          {" "}
          <RenderAddHersteller />
        </span>
        .
      </p>
    </div>
  );
  let herstAddedlist = useRef([]);
  const searchHerstellerList = (inputString) => {
    setGlobalSpinner(true);
    EquipmentGroupActions.getHerstelleres(inputString);
  };

  const getHerstellerByEquGroupId = (equGrpId) => {
    setGlobalSpinner(true);
    EquipmentGroupActions.getHerstellerByEquGrpId(equGrpId);
  };
  /**--------useEffect for Button Disabled Start---------------------- */

  useEffect(() => {
    if (selectedHerstellerId !== 0) {
      setbuttonStatus(false);
    } else {
      setbuttonStatus(true);
    }
  }, [selectedHerstellerId]);

  /**--------useEffect for Button Disabled End---------------------- */
  useEffect(() => {
    if (equipmentGrpId) {
      equipmentId.current = equipmentGrpId;
      getHerstellerByEquGroupId(equipmentGrpId);
    }

    return () => {};
  }, [equipmentGrpId]);

  const addHerstellerToEquipmentGroup = (e) => {
    e.preventDefault();
    const HerstellerData = {
      HerstellerID: selectedHerstellerId,
      AnlagegruppeID: equipmentGrpId,
    };
    setGlobalSpinner(true);
    EquipmentGroupActions.addAnlagegruppeHersteller(HerstellerData);
  };

  useEffect(() => {
    function searchHerstellerListSuccess() {
      const res = equipmentGroupStore.getHerstellers();
      let herList = [];
      if (res.length > 0) {
        res.map((key, index) => {
          herList.push({ id: key.id, label: key.hersteller });
        });

        const tempList = herList.filter((items) => {
          return herstAddedlist.current.every((element) => {
            return element != items.id;
          });
        });
        setSearchedHerstellerList(tempList);
      } else {
        setSearchedHerstellerList([]);
      }
      setGlobalSpinner(false);
    }

    function searchHerstellerListFailure() {
      setGlobalSpinner(false);
    }

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_HERSTELLERS_SUCCESS,
      searchHerstellerListSuccess,
    );

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_HERSTELLERS_FAILURE,
      searchHerstellerListFailure,
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_HERSTELLERS_SUCCESS,
        searchHerstellerListSuccess,
      );

      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_HERSTELLERS_FAILURE,
        searchHerstellerListFailure,
      );
    };
  }, [searchedHerstellerList]);
  useEffect(() => {
    let _tempItem = [];
    herstAddedlist.current = herstellerList.map((items) => {
      _tempItem.push({ id: items.id, label: items.hersteller });
      return items.id;
    });
    setListItem(_tempItem);
  }, [herstellerList]);

  useEffect(() => {
    function getHerstellerByEquGroupIdSuccess() {
      const res = equipmentGroupStore.getHerstellerByEquGroup();
      if (res.length > 0) {
        setHerstellerList(res);
      } else {
        setHerstellerList([]);
      }
      handleCompleted("AddManufacture", res.length > 0);
      setGlobalSpinner(false);
    }

    function getHerstellerByEquGroupIdFailure() {
      const res = equipmentGroupStore.getHerstellerByEquGroup();
      toast.error(res);
      setGlobalSpinner(false);
    }

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_HERSTELLER_BY_EQUIPMENT_GROUP_ID_SUCCESS,
      getHerstellerByEquGroupIdSuccess,
    );

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_HERSTELLER_BY_EQUIPMENT_GROUP_ID_FAILURE,
      getHerstellerByEquGroupIdFailure,
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_HERSTELLER_BY_EQUIPMENT_GROUP_ID_SUCCESS,
        getHerstellerByEquGroupIdSuccess,
      );

      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_HERSTELLER_BY_EQUIPMENT_GROUP_ID_FAILURE,
        getHerstellerByEquGroupIdFailure,
      );
    };
  }, []);
  useEffect(() => {
    function addHerstellerToEquGroupSuccess() {
      const res = equipmentGroupStore.getAddHerstellerToEquGrp();
      setSelectedHerstellerId(0);
      setSearchedHerstellerList([]);
      if (res) {
        getHerstellerByEquGroupId(equipmentId.current);
        toast.success(localization.herstellerAddedToEquipmentGroup);
      }
      typeHeadRef.current.resetTypeHead();
      setGlobalSpinner(false);
    }

    function addHerstellerToEquGroupFailure() {
      const res = equipmentGroupStore.getAddHerstellerToEquGrp();
      toast.error(res);
      setGlobalSpinner(false);
    }

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.ADD_HERSTELLER_BY_EQUIPMENT_GROUP_ID_SUCCESS,
      addHerstellerToEquGroupSuccess,
    );

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.ADD_HERSTELLER_BY_EQUIPMENT_GROUP_ID_FAILURE,
      addHerstellerToEquGroupFailure,
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.ADD_HERSTELLER_BY_EQUIPMENT_GROUP_ID_SUCCESS,
        addHerstellerToEquGroupSuccess,
      );

      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.ADD_HERSTELLER_BY_EQUIPMENT_GROUP_ID_FAILURE,
        addHerstellerToEquGroupFailure,
      );
    };
  }, []);

  useEffect(() => {
    function deleteHerstellerToEupGrpSuccess() {
      const res = equipmentGroupStore.getDeleteherstellerToequGrp();
      if (res.length > 0) {
        toast.error(
          "You can not delete this manufacturer as it has associated equipments." +
            res.join(","),
        );
      } else {
        toast.success(localization.herstellerRemoveSuccessfully);
      }
      getHerstellerByEquGroupId(equipmentId.current);
    }

    function deleteHerstellerToEupGrpFailure() {
      const res = equipmentGroupStore.getDeleteherstellerToequGrp();
      toast.error(res);
      setGlobalSpinner(false);
    }

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.DELETE_HERSTELLER_BY_EQUIPMENT_GROUP_SUCCESS,
      deleteHerstellerToEupGrpSuccess,
    );

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.DELETE_HERSTELLER_BY_EQUIPMENT_GROUP_FAILURE,
      deleteHerstellerToEupGrpFailure,
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.DELETE_HERSTELLER_BY_EQUIPMENT_GROUP_SUCCESS,
        deleteHerstellerToEupGrpSuccess,
      );

      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.DELETE_HERSTELLER_BY_EQUIPMENT_GROUP_FAILURE,
        deleteHerstellerToEupGrpFailure,
      );
    };
  }, []);

  const typeAheadInputChangeCallback = (text) => {
    if (text !== "") {
      searchHerstellerList(text);
    } else {
      setSelectedHerstellerId(0);
    }
  };

  const typeAheadSelectedCallback = (selectedList) => {
    if (selectedList && selectedList.length > 0) {
      setSelectedHerstellerId(selectedList[0].id);
    }
  };

  function handleSelectedItem() {
    setSelectedHerstellerId(0);
  }

  function handleDeleteButton() {
    setConfirmationPopUpOpen(true);
    setConfirmationPopUpMsg(
      localization.deleteWithout +
        " " +
        itemSelected.length +
        " " +
        localization.manufacturer +
        " ?",
    );
    setCallbackData({
      equGrpId: equipmentGrpId,
      HerstellerID: itemSelected,
    });
    setEventType("DELETE_HERSTELLER_FOR_EQU_GRP");
  }

  const confirmationOkCancelCallback = (isConfirmed, eventType, data) => {
    if (isConfirmed) {
      switch (eventType) {
        case "DELETE_HERSTELLER_FOR_EQU_GRP":
          setGlobalSpinner(true);
          EquipmentGroupActions.deleteHerstellerForEquGroup(
            data.equGrpId,
            data.HerstellerID,
          );
          closePopUpCallback();
          break;
        default:
          break;
      }
    } else {
      closePopUpCallback();
    }
  };

  const closePopUpCallback = () => {
    setConfirmationPopUpOpen(false);
    setConfirmationPopUpMsg("");
    setCallbackData(null);
    setEventType(null);
  };

  const resetShowMessageOnPopUpFlag = () => {
    setSelectedHerstellerId(0);
    typeHeadRef.current.resetTypeHead();
    commonUtils.setShowMessageOnPopUp(false);
  };

  useEffect(() => {
    function addOrUpdateHerstellerSuccess() {
      const res = equipmentGroupStore.getAddOrUpdateHerstellers();

      if (res) {
        commonUtils.hideModalPopUp("addHerstellerModalClose");
        toast.success(localization.herstellersAddSuccessfully);
        EquipmentGroupActions.addAnlagegruppeHersteller({
          HerstellerID: res.id,
          AnlagegruppeID: equipmentId.current,
        });
      } else {
        toast.error(res);
      }
      setGlobalSpinner(false);
    }

    function addOrUpdateHerstellerFailure() {
      const res = equipmentGroupStore.getAddOrUpdateHerstellers();

      toast.error(res);
      setGlobalSpinner(false);
    }

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.ADD_OR_UPDATE_HERSTELLERS_SUCCESS,
      addOrUpdateHerstellerSuccess,
    );

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.ADD_OR_UPDATE_HERSTELLERS_FAILURE,
      addOrUpdateHerstellerFailure,
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.ADD_OR_UPDATE_HERSTELLERS_SUCCESS,
        addOrUpdateHerstellerSuccess,
      );

      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.ADD_OR_UPDATE_HERSTELLERS_FAILURE,
        addOrUpdateHerstellerFailure,
      );
    };
  }, []);

  function RenderAddHersteller() {
    return (
      <>
        <span
          id="addHerstellerTest"
          className=" cursorPoint"
          size={27}
          onClick={() => {}}
          data-toggle="modal"
          data-target="#addHersteller"
        >
          {localization.here}
        </span>
      </>
    );
  }
  return (
    <>
      <div className="row d-flex justify-content-center">
        <ReusableCard
          title=""
          func={addHerstellerToEquipmentGroup}
          buttonStatus={buttonStatus}
          buttonname={localization.save}
          text={text}
        >
          <TypeAhead
            ref={typeHeadRef}
            typeAheadInputChangeCallback={typeAheadInputChangeCallback}
            typeAheadSelectedCallback={typeAheadSelectedCallback}
            isMultiple={false}
            searchedList={searchedHerstellerList}
            resetSelectedItem={handleSelectedItem}
          />
        </ReusableCard>
      </div>
      <EnhancedTable
        tableHeaders={[localization.name]}
        ItemList={listItem}
        title={localization.herstellerList}
        columnName={localization.manufacturer}
        setItemSelected={setItemSelected}
        deletdHandle={handleDeleteButton}
      />
      <ConfirmationPopUp
        isOpen={confirmationPopUpOpen}
        okCancelCallback={confirmationOkCancelCallback}
        close={closePopUpCallback}
        title=""
        msg={confirmationPopUpMsg}
        eventType={eventType}
        callbackData={callbackData}
      />
    </>
  );
};

export default AddHerstellerToEquGroup;
